import { render, staticRenderFns } from "./CotacaoFreteRespostaLineOptions.vue?vue&type=template&id=b817f99c&"
import script from "./CotacaoFreteRespostaLineOptions.vue?vue&type=script&lang=js&"
export * from "./CotacaoFreteRespostaLineOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
